import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import BreadCrumbContainer from '../common/breadcrumbContainer/breadcrumbContainer';

import TeamTimeCardContainer from './TeamTimeCardContainer';

import { setBreadcrumb } from '../common/breadcrumbContainer/state/breadcrumb.actions';
import { getUsers } from '../users/state/users.actions';
import { getTeams } from '../teams/state/teams.actions';
import { getApprovals } from '../clock/state/clockin.actions';
import { getUnions } from '../unions/state/unions.actions';
import { getSageShifts } from '../sage/state/sage.actions';
import { getTablets } from '../tablets/state/tablets.actions';

import colors from '../constants/Colors';

const BASE_CRUMBS = [{
  text: 'Time Cards',
  icon: 'carry-out',
}, {
  text: 'Team Cards',
}];

function TeamTimeCards() {
  const dispatch = useDispatch();

  const crumbs = useSelector((state) => state.breadcrumb);
  const selectedDivisions = useSelector((state) => state.settings.selectedDivisions);
  const menuCollapsed = useSelector((state) => state.main.menuCollapsed);

  useEffect(() => {
    dispatch(getTeams());
    dispatch(getUsers());
    dispatch(getApprovals('Team Time Cards Page'));
    dispatch(getUnions());
    dispatch(getTablets());
    dispatch(setBreadcrumb(BASE_CRUMBS));
  }, []);

  useEffect(() => {
    dispatch(getSageShifts({ divisionIds: Array.from(selectedDivisions) }));
  }, [selectedDivisions]);

  const onUserSelected = useCallback((name) => {
    dispatch(setBreadcrumb(BASE_CRUMBS.concat({ text: name })));
  }, [dispatch, crumbs]);

  return (
    <BreadCrumbContainer
      fullscreen={menuCollapsed}
      bodyStyle={{
        margin: 0,
        paddingLeft: 0,
        height: menuCollapsed ? '100vh' : 'calc(100vh - 72px)',
        background: colors.GRAY_50,
      }}
      crumbStyle={{ margin: 0, paddingLeft: 0 }}
    >
      <TeamTimeCardContainer
        onUserSelect={onUserSelected}
      />
    </BreadCrumbContainer>
  );
}

export default TeamTimeCards;
